import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({
  title = 'GraveForge | Solana Deads NFT Manufacturing Stack',
  description = 'GraveForge powers Solana Deads-grade NFT collections with AI-assisted rules, decision tree generation, duplicate prevention, and multi-chain exports for Solana, Ethereum, Base, and Abstract.',
  keywords = [
    'solana nft generator',
    'rule based nft engine',
    'multi chain nft builder',
    'nft manufacturing platform',
    'graveforge',
    'solana deads'
  ],
  image = 'https://images.solanadeads.com/graveforge.png',
  imageAlt = 'GraveForge Solana Deads control room interface',
  creator = '@SOLANADEADS',
  type = 'website',
  noIndex = false,
  canonicalUrl,
  structuredData,
  children,
}) => {
  const { pathname } = useLocation();
  const siteUrl = 'https://graveforge.io';
  const url = canonicalUrl || `${siteUrl}${pathname}`;
  const normalizedKeywords = Array.isArray(keywords) ? keywords.join(', ') : keywords;
  return (
    <Helmet>
      {/* Standard metadata */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={normalizedKeywords} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {/* Canonical URL */}
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:site_name" content="GraveForge" />
      <meta property="og:locale" content="en_US" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:creator" content={creator || '@SOLANADEADS'} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@solanadeads" />
      <meta name="twitter:image:alt" content={imageAlt} />
      {/* Additional meta tags */}
      <meta name="theme-color" content="#a32828" />
      <meta name="msapplication-TileColor" content="#a32828" />
      <meta name="msapplication-config" content="/browserconfig.xml" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#dc2626" />
      <meta name="application-name" content="GraveForge" />
      <meta name="author" content="Solana Deads" />
      <meta name="publisher" content="Solana Deads" />
      {/* Additional children elements */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
      {children}
    </Helmet>
  );
};

export default SEO;
